import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EHideCommentActionType {
  Succeed = 'postComments/hideComment/succeed',
}

export type THideCommentSucceed = ITypedReduxAction<EHideCommentActionType.Succeed, number>;

export type THideComment = THideCommentSucceed;
